import _ from 'lodash';

import DecimalForGlobals from '../impuestos/DecimalForGlobals';

class NominaDeduccionesCalculator {

  data = {}

  constructor(data) {
    this.data = data;
  }

  static make(data) {
    return new NominaDeduccionesCalculator(data);
  }

  get() {
    const totalOtrasDeducciones = this.getTotalOtrasDeducciones();
    const totalImpuestosRetenidos = this.getTotalImpuestosRetenidos();

    return {
      totalOtrasDeducciones,
      totalImpuestosRetenidos
    }
  }

  getTotalOtrasDeducciones() {
    const exept = [
      '002', // (ISR)
    ];

    const total = _.sumBy(this._getDeducciones(exept), (item) => {
      return parseFloat(item.Importe);
    });

    return total !== undefined ? DecimalForGlobals.make(total).toFixed() : undefined;
  }

  getTotalImpuestosRetenidos() {
    const only = [
      '002', // (ISR)
    ];

    const total = _.sumBy(this._getDeducciones(only, 1), (item) => {
      return parseFloat(item.Importe);
    });

    return total !== undefined ? DecimalForGlobals.make(total).toFixed() : undefined;
  }

  _getDeducciones(haystack = [], flag = 0) {
    if (flag === 1) {
      return this.data.filter((item) => {
        return haystack.indexOf(item.TipoDeduccion) !== -1;
      });
    }

    return this.data.filter((item) => {
      return haystack.indexOf(item.TipoDeduccion) === -1;
    });
  }

}

export default NominaDeduccionesCalculator;